<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import {
  INTERFACE_THEMES,
  getInterfaceThemePreviewClass,
  normalizeInterfaceTheme,
} from 'shared/helpers/chatBackground';
import { applyInterfaceTheme } from 'dashboard/helper/themeHelper';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const selectedTheme = computed(() =>
  normalizeInterfaceTheme(
    uiSettings.value.interface_theme ||
      uiSettings.value.chat_background_theme ||
      'system'
  )
);
const themes = computed(() =>
  INTERFACE_THEMES.map(theme => ({
    ...theme,
    // Theme values are a closed, trusted list defined in chatBackground.js.
    // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
    label: t(
      `PROFILE_SETTINGS.FORM.CHAT_BACKGROUND.OPTIONS.${theme.value.toUpperCase()}`
    ),
  }))
);

const selectTheme = theme => {
  applyInterfaceTheme(theme);
  updateUISettings({ interface_theme: theme });
  useAlert(t('PROFILE_SETTINGS.FORM.CHAT_BACKGROUND.UPDATE_SUCCESS'));
};
</script>

<template>
  <div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
    <button
      v-for="theme in themes"
      :key="theme.value"
      type="button"
      class="overflow-hidden rounded-xl border text-left transition hover:border-n-brand"
      :class="
        selectedTheme === theme.value
          ? 'border-n-brand ring-2 ring-n-brand/20'
          : 'border-n-weak'
      "
      @click="selectTheme(theme.value)"
    >
      <span
        class="block h-16 border-b border-n-weak"
        :class="getInterfaceThemePreviewClass(theme.value)"
      />
      <span class="block bg-n-surface-1 px-3 py-2 text-sm text-n-slate-12">
        {{ theme.label }}
      </span>
    </button>
  </div>
</template>
